import { application } from './application.js'

import AutoSubmitFormController from './auto_submit_form_controller.js'
import ClipboardController from './clipboard_controller.js'
import DoubleSidedKycDocumentController from './double_sided_kyc_document_controller.js'
import FlashController from './flash_controller.js'
import KycDocumentController from './kyc_document_controller.js'
import PasswordToggleController from './password_toggle_controller.js'
import SignatureCallbackController from './signature_callback_controller.js'
import TaxExemptionSignatureController from './tax_exemption_signature_controller.js'

application.register('auto-submit-form', AutoSubmitFormController);
application.register('clipboard', ClipboardController);
application.register('double-sided-kyc-document', DoubleSidedKycDocumentController);
application.register('flash', FlashController);
application.register('kyc-document', KycDocumentController);
application.register('password-toggle', PasswordToggleController);
application.register('signature-callback', SignatureCallbackController);
application.register('tax-exemption-signature', TaxExemptionSignatureController);
